var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.24062C1 5.0562 1 3.96399 1.43597 3.12965C1.81947 2.39574 2.43139 1.79906 3.18404 1.42512C4.03969 1 5.15979 1 7.4 1H18.6C20.8402 1 21.9603 1 22.816 1.42512C23.5686 1.79906 24.1805 2.39574 24.564 3.12965C25 3.96399 25 5.0562 25 7.24063V14.2613C25 16.4458 25 17.538 24.564 18.3723C24.1805 19.1062 23.5686 19.7029 22.816 20.0768C21.9603 20.502 20.8402 20.502 18.6 20.502H15.245C14.4129 20.502 13.9969 20.502 13.599 20.5816C13.2459 20.6522 12.9043 20.7691 12.5833 20.929C12.2216 21.1092 11.8967 21.3626 11.247 21.8695L8.06634 24.3506C7.51156 24.7834 7.23417 24.9998 7.00072 25C6.79769 25.0002 6.60563 24.9102 6.47897 24.7555C6.33333 24.5776 6.33333 24.2312 6.33333 23.5384V20.502C5.09337 20.502 4.47339 20.502 3.96472 20.3691C2.58436 20.0084 1.50617 18.9571 1.1363 17.6111C1 17.1151 1 16.5105 1 15.3014V7.24062Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.5H8.51M13 11.5H13.01M17.5 11.5H17.51M9 11.5C9 11.7761 8.77614 12 8.5 12C8.22386 12 8 11.7761 8 11.5C8 11.2239 8.22386 11 8.5 11C8.77614 11 9 11.2239 9 11.5ZM13.5 11.5C13.5 11.7761 13.2761 12 13 12C12.7239 12 12.5 11.7761 12.5 11.5C12.5 11.2239 12.7239 11 13 11C13.2761 11 13.5 11.2239 13.5 11.5ZM18 11.5C18 11.7761 17.7761 12 17.5 12C17.2239 12 17 11.7761 17 11.5C17 11.2239 17.2239 11 17.5 11C17.7761 11 18 11.2239 18 11.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.84ef1aecc6a32daec19ffc1f0e1364fc.svg";
export { ForwardRef as ReactComponent };